/**
 * @generated SignedSource<<e8c066e0510dde9071c9aae32d61523c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "formId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FormDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteFormTPayload",
        "kind": "LinkedField",
        "name": "deleteFormTByFormId",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "FormT",
            "kind": "LinkedField",
            "name": "formT",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FormDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteFormTPayload",
        "kind": "LinkedField",
        "name": "deleteFormTByFormId",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "FormT",
            "kind": "LinkedField",
            "name": "formT",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "nodeId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b5daf171fb2f13e591883933fd3c2eb7",
    "id": null,
    "metadata": {},
    "name": "FormDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation FormDeleteMutation(\n  $input: DeleteFormTByFormIdInput!\n) {\n  deleteFormTByFormId(input: $input) {\n    formT {\n      formId\n      nodeId\n    }\n  }\n}\n"
  }
};
})();

node.hash = "d6b8390f073514cb7bfb4137593a4a8a";

module.exports = node;
